import { differenceInMinutes } from 'date-fns';
import moment from 'moment/moment';
import React, { useEffect, useState } from 'react';

type Props = {
  startedAt: string | Date;
  endedAt?: string | Date | null;
};

export default function TimeTrackingEntryDuration({ startedAt, endedAt }: Props) {
  const [duration, setDuration] = useState<string>('00:00');

  useEffect(() => {
    const updateDuration = () => {
      const start = moment.utc(startedAt);
      const end = endedAt ? moment.utc(endedAt) : moment();
      const diffInMinutes = end.diff(start, 'minutes');
      const hours = Math.floor(diffInMinutes / 60);
      const minutes = diffInMinutes % 60;

      setDuration(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`);
    };

    updateDuration();
    const intervalId = setInterval(updateDuration, 60000); // Update every minute

    return () => clearInterval(intervalId);
  }, [startedAt, endedAt]);

  return <span>{duration}</span>;
}
